import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../styles/styles";
import Config from "../config/Config";
import TextDiv from "./containers/TextDiv";
import {useSelector} from "react-redux";

const Links = {
    PRIVACY: "https://www.avast.com/privacy-policy",
    LICENCE: "https://www.avast.com/eula",
    ABOUT: "https://www.avast.com/about",
    HOME: "https://www.avast.com",
};

function openLink(link) {
    window.open(link, "_self");
}

const AvastFooterMobile = ({extraStyle}) => {
    const styles = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content 48px max-content", "1fr"),
                backgroundColor: Config.colors.FOOTER_BACKGROUND,
                color: Config.colors.FOOTER_LINK,
                fontSize: 12,
                lineHeight: 1.33,
                letterSpacing: "-0.1px",
                padding: "24px 0",
                textAlign: "center"
            },
            topFrame: {
                ...GridStyles.setRowCol(1, 1),
                ...GridStyles.define("max-content max-content max-content max-content max-content", "auto")
            },
            bottomFrame: {
                ...GridStyles.setRowCol(3, 1),
                ...GridStyles.define("max-content max-content max-content", "auto")
            }
        }),
        footerDividerStyles = (row, hover = true) => StyleSheet.create({
                container: {
                    ...GridStyles.setRowCol(row, 1),
                    ":hover": hover ? {
                        cursor: "pointer",
                        color: Config.colors.FOOTER_LINK_HOVER
                    } : {}
                }
            }
        ),
        footerSeparatorStyles = (row) => StyleSheet.create({
                container: {
                    ...GridStyles.setRowCol(row, 1),
                    margin: "13px 0 12px 0"
                }
            }
        );

    return (
        <div id={Config.styles.FOOTER_ID} className={css(styles.container, extraStyle)}>
            <div className={css(styles.topFrame)}>
                <TextDiv text={Config.messages.copyrights} extraStyle={footerDividerStyles(1, false).container}/>
                <TextDiv text={"_"} extraStyle={footerSeparatorStyles(2).container}/>
                <TextDiv onClick={() => openLink(Links.PRIVACY)} text={Config.messages.privacy}
                         extraStyle={footerDividerStyles(3).container}/>
                <TextDiv text={"_"} extraStyle={footerSeparatorStyles(4).container}/>
                <TextDiv onClick={() => openLink(Links.LICENCE)} text={Config.messages.licence}
                         extraStyle={footerDividerStyles(5).container}/>
            </div>
            <div className={css(styles.bottomFrame)}>
                <TextDiv onClick={() => openLink(Links.ABOUT)} text={Config.messages.about}
                         extraStyle={footerDividerStyles(1).container}/>
                <TextDiv text={"_"} extraStyle={footerSeparatorStyles(2).container}/>
                <TextDiv onClick={() => openLink(Links.HOME)} text={Config.messages.homepage}
                         extraStyle={footerDividerStyles(3).container}/>
            </div>
        </div>
    );
};

const AvastFooterRegular = ({extraStyle}) => {
    const styles = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content", "minmax(20px, auto) max-content minmax(10px, 540px) max-content minmax(20px, auto)"),
                backgroundColor: Config.colors.FOOTER_BACKGROUND,
                color: Config.colors.FOOTER_LINK,
                lineHeight: 1.33,
                fontSize: 12,
                paddingBottom: 20,
                paddingTop: 24,
                letterSpacing: "-0.1px"
            },
            leftFrame: {
                ...GridStyles.setRowCol(1, 2),
                ...GridStyles.define("max-content", "max-content max-content max-content max-content max-content")
            },
            rightFrame: {
                ...GridStyles.setRowCol(1, 4),
                ...GridStyles.define("max-content", "max-content max-content max-content")
            }
        }),
        footerDividerStyles = (col, hover = true) => StyleSheet.create({
                container: {
                    ...GridStyles.setRowCol(1, col),
                    ":hover": hover ? {
                        cursor: "pointer",
                        color: Config.colors.FOOTER_LINK_HOVER
                    } : {}
                }
            }
        ),
        footerSeparatorStyles = (col) => StyleSheet.create({
                container: {
                    ...GridStyles.setRowCol(1, col),
                    margin: "0 10px"
                }
            }
        );

    return (
        <div id={Config.styles.FOOTER_ID} className={css(styles.container, extraStyle)}>
            <div className={css(styles.leftFrame)}>
                <TextDiv text={Config.messages.copyrights} extraStyle={footerDividerStyles(1, false).container}/>
                <TextDiv text={"|"} extraStyle={footerSeparatorStyles(2).container}/>
                <TextDiv onClick={() => openLink(Links.PRIVACY)} text={Config.messages.privacy}
                         extraStyle={footerDividerStyles(3).container}/>
                <TextDiv text={"|"} extraStyle={footerSeparatorStyles(4).container}/>
                <TextDiv onClick={() => openLink(Links.LICENCE)} text={Config.messages.licence}
                         extraStyle={footerDividerStyles(5).container}/>
            </div>
            <div className={css(styles.rightFrame)}>
                <TextDiv onClick={() => openLink(Links.ABOUT)} text={Config.messages.about}
                         extraStyle={footerDividerStyles(1).container}/>
                <TextDiv text={"|"} extraStyle={footerSeparatorStyles(2).container}/>
                <TextDiv onClick={() => openLink(Links.HOME)} text={Config.messages.homepage}
                         extraStyle={footerDividerStyles(3).container}/>
            </div>
        </div>
    );
};


const AvastFooter = ({extraStyle}) => {
    const {isMobile} = useSelector(state => state.styles);

    return isMobile ? <AvastFooterMobile extraStyle={extraStyle}/> : <AvastFooterRegular extraStyle={extraStyle}/>;
};

export default AvastFooter;
